import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useT } from '@/i18n'
import { SkeletonRows } from '@/components/rm'
import { BookingForm } from '@/components/booking-form'
import { usePublicListing } from '@/lib/listing'
import { useBookingActions } from '@/lib/bookings'
import { errorText } from '@/lib/utils'

// Spec 007 US1. Book a listed fixed-price service.
export const Route = createFileRoute('/_client/hire/$slug/$service')({ component: Hire })

function Hire() {
  const { slug, service } = Route.useParams()
  const { t } = useT()
  const navigate = useNavigate()
  const listing = usePublicListing(slug)
  const { request } = useBookingActions()
  const s = listing.data?.services.find((x) => x.id === service)

  if (listing.isLoading) return <SkeletonRows count={4} />
  if (!listing.data || !s || s.price == null) return <p className="text-[14px] text-token-secondary">{t('pub.notFound')}</p>

  return (
    <div className="mx-auto max-w-md space-y-4">
      <div>
        <h1 className="font-display text-[22px] font-bold leading-tight tracking-[-0.02em] text-token-primary">{t('bk.title', { service: s.name })}</h1>
        <p className="text-[13.5px] text-token-secondary">{t('bk.with', { business: listing.data.business_name })}</p>
      </div>
      <BookingForm priceCentavos={Math.round(s.price * 100)} submitLabel={t('bk.request')} busyLabel={t('bk.requesting')} busy={request.isPending}
        onSubmit={async (b) => {
          try {
            const id = await request.mutateAsync({ service: s.id, ...b })
            navigate({ to: '/bookings/$id', params: { id } })
            return null
          } catch (e) { return /2 hours/.test(errorText(e, '')) ? t('bk.tooSoon') : t('bk.failed') }
        }} />
      <p className="text-[12.5px] text-token-muted">{t('bk.requestHint')}</p>
    </div>
  )
}
